import type { TrainingBlock } from '../../../types/training';

export const relabelTrainingBlocks = (
  blocks: TrainingBlock[],
  labels: string[],
): TrainingBlock[] => blocks.map((block, index) => ({
  ...block,
  label: labels[index] ?? block.label,
}));

export const moveBlockByIds = (
  blocks: TrainingBlock[],
  sourceBlockId: string,
  targetBlockId: string,
  labels: string[],
): TrainingBlock[] => {
  if (sourceBlockId === targetBlockId) {
    return blocks;
  }

  const sourceIndex = blocks.findIndex((block) => block.id === sourceBlockId);
  const targetIndex = blocks.findIndex((block) => block.id === targetBlockId);

  if (sourceIndex < 0 || targetIndex < 0) {
    return blocks;
  }

  const nextBlocks = [...blocks];
  const [movedBlock] = nextBlocks.splice(sourceIndex, 1);
  nextBlocks.splice(targetIndex, 0, movedBlock);

  return relabelTrainingBlocks(nextBlocks, labels);
};

export const moveBlockToLabel = (
  blocks: TrainingBlock[],
  sourceBlockId: string,
  targetLabel: string,
  labels: string[],
): TrainingBlock[] => {
  const targetBlock = blocks.find((block) => block.label === targetLabel);
  if (!targetBlock) {
    return blocks;
  }

  return moveBlockByIds(blocks, sourceBlockId, targetBlock.id, labels);
};
